<template>
  <bg-style
    v-imloading="loading"
    class="consecutive-widget"
    :class="isMobile ? 'activity_content_mobile relative' : 'activity_content_desk relative'"
    :bg="model.background"
    :mobile-bg="model.mobileBackground"
  >
    <module-block :max-content-width="1280">
      <div v-if="model.titleVisible" class="title" :class="[!isMobile ? 'mb-[8px]' : 'mb-[4px]']">
        <rich-text
          v-model="model.title"
          :editing="editing"
          :stroke.sync="model.titleStroke"
          :disabled="!editing"
          placement="top"
          theme="snow"
        />
      </div>
      <div v-if="model.subtitleVisible" class="describe" :class="[!isMobile ? 'mb-[40px]' : 'mb-[16px]']">
        <rich-text
          v-model="model.subtitle"
          :stroke.sync="model.subTitleStroke"
          :editing="editing"
          :disabled="!editing"
          placement="top"
          theme="snow"
        />
      </div>
      <content-component :model="model" :editing="editing" :is-mobile="isMobile" @show-loading="showLoading" @hide-loading="hideLoading" />
    </module-block>
  </bg-style>
</template>

<script>
import ContentComponent from './content.vue'
import richText from '~/components/richText'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

export default {
  name: 'ActivityWidgetEdit',
  components: {
    ModuleBlock,
    richText,
    ContentComponent
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    },
    device: {
      type: String,
      default: 'desktop',
    },
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    showTitle() {
      const res = this.model.layout.find((m) => {
        return m.key === 'activityTitle'
      })
      return res && res.value
    },
    isMobile() {
      return this.device === 'mobile'
    }
  },
  methods: {
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>

.activity_content_desk {
  padding: 20px 0;

}

.activity_content_mobile {
  padding: 10px;
  .title, .describe {
    padding: 0 11px;
  }
}
</style>
